module.exports = __webpack_public_path__ + "img/hd1.18bc1bdf.png";